import React, { useEffect, useState } from "react";
import { gettext } from "web/script/modules/django-i18n";
import analytics from "web/script/analytics/analytics";
import SendToAppModal from "web/react/components/send-to-app-modal/send-to-app-modal";
import { RawBranchLink } from "web/script/utils/branch-io";
import browser from "web/script/utils/browser";
import environment from "web/script/modules/environment";
import userProfiler from "web/script/modules/userprofiler";
import history from "web/script/utils/history";
import { useOverlayWatcher } from "web/react/hooks/use-overlay-watcher/use-overlay-watcher";
import globals from "web/script/modules/globals";
import classnames from "classnames";

const SOFT_BLOCK = "soft_block";
const HARD_BLOCK = "hard_block";
const NO_BLOCK = "no_block";
const TITLE_1 = "title_1";
const TITLE_2 = "title_2";
const TITLE_3 = "title_3";
const TITLE_4 = "title_4";
const APP_MODAL_NAME = "send-to-app-on-oos-related-show-more-modal";

interface RelatedProductsSectionProp {
    view_more_url: string;
    product_is_instock?: boolean;
}

export function RelatedProductsShowMore(section: RelatedProductsSectionProp): JSX.Element {
    const isIos = browser.ios;
    const productIsInstock = section.product_is_instock != null && section.product_is_instock;
    let blockVariant;
    if (isIos) {
        blockVariant = productIsInstock
            ? environment.getFeature("mg_block_is_related_show_more")
            : environment.getFeature("mg_block_oos_related_show_more");
    } else {
        blockVariant = NO_BLOCK;
    }

    let [blocked, setBlocked] = useState(true);
    const blockModalIsOpen = !!useOverlayWatcher(APP_MODAL_NAME);

    const branchLink = productIsInstock
        ? RawBranchLink.InStockShowMore
        : RawBranchLink.OutOfStockShowMore;

    const titleVariant = productIsInstock
        ? environment.getFeature("mg_block_is_related_show_more_title")
        : environment.getFeature("mg_block_oos_related_show_more_title");

    let blockingTitle = "";
    if (titleVariant == TITLE_1) {
        blockingTitle = productIsInstock
            ? // "Shop the world’s biggest and best selection of fashion"
              gettext("in_stock_product.related_show_more.app_overlay_block.title_1")
            : // "Shop the world’s biggest and best selection of fashion"
              gettext("oos_product.related_show_more.app_overlay_block.title_1");
    } else if (titleVariant == TITLE_2) {
        blockingTitle = productIsInstock
            ? // "The hottest and newest products from over 12,000 brands"
              gettext("in_stock_product.related_show_more.app_overlay_block.title_2")
            : // "The hottest and newest products from over 12,000 brands"
              gettext("oos_product.related_show_more.app_overlay_block.title_2");
    } else if (titleVariant == TITLE_3) {
        blockingTitle = productIsInstock
            ? // "Can’t find what you’re looking for? The Lyst App is personalised to you"
              gettext("in_stock_product.related_show_more.app_overlay_block.title_3")
            : // "Can’t find what you’re looking for? The Lyst App is personalised to you"
              gettext("oos_product.related_show_more.app_overlay_block.title_3");
    } else if (titleVariant == TITLE_4) {
        blockingTitle = productIsInstock
            ? // "Still not sure what you want? Keep track of your favourite items in the app"
              gettext("in_stock_product.related_show_more.app_overlay_block.title_4")
            : // "Still not sure what you want? Keep track of your favourite items in the app"
              gettext("oos_product.related_show_more.app_overlay_block.title_4");
    }

    function onBlockModalOpen(): void {
        // I check the current overlay state instead of modalIsOpen
        // to get around the delay introduced by hooks
        if (history.getCurrentState().overlay !== APP_MODAL_NAME) {
            history.pushOverlay(APP_MODAL_NAME);
        }
    }

    function onButtonClick(): void {
        analytics.event("navigation", "show_more_related", "show_feed");
        if (isIos && !userProfiler.isLoggedIn()) {
            if (blockVariant == HARD_BLOCK) {
                onBlockModalOpen();
                return;
            } else if (blockVariant == SOFT_BLOCK && blocked) {
                setBlocked(false);
                onBlockModalOpen();
                return;
            }
        }
        // If we don't meet the requirements to open the modal, we use default behaviour
        globals.window.location.href = section.view_more_url;
    }

    function onBlockModalClose(): void {
        history.popOverlay(APP_MODAL_NAME);

        // when dismissing a soft block we will open the feature
        if (blockVariant === SOFT_BLOCK) {
            globals.window.location.href = section.view_more_url;
        }
    }

    const [isPaywalled, setIsPaywalled] = useState(false);
    const paywalledClassName = "paywalled-content";
    useEffect(() => {
        setIsPaywalled(blockVariant === HARD_BLOCK);
    }, [blockVariant]);

    return (
        <div className={classnames({ [paywalledClassName]: isPaywalled })}>
            <button className="btn btn-primary related-show-more" onClick={onButtonClick}>
                {gettext("product.related_products.show_me_more")}
            </button>
            <SendToAppModal
                title={blockingTitle}
                url={branchLink}
                isOpen={blockModalIsOpen}
                onClose={onBlockModalClose}
                analyticsEventLabel={"oos_related_show_more"}
                paywalledClassName={isPaywalled ? paywalledClassName : null}
            />
        </div>
    );
}

export default RelatedProductsShowMore;
